import { InvoiceRepository } from '../../domain/repositories/InvoiceRepository';
import { PaymentRepository } from '../../domain/repositories/PaymentRepository';
import { DisponibilidadHorariaRepository } from '../../domain/repositories/DisponibilidadHorariaRepository';
import { RecordatorioRepository } from '../../domain/repositories/RecordatorioRepository';
import { ApiInvoiceRepository } from './ApiInvoiceRepository';
import { ApiPaymentRepository } from './ApiPaymentRepository';
import { ApiDisponibilidadHorariaRepository } from './ApiDisponibilidadHorariaRepository';
import { ApiRecordatorioRepository } from './ApiRecordatorioRepository';
import { MockInvoiceRepository } from './MockInvoiceRepository';
import { MockPaymentRepository } from './MockPaymentRepository';
import { MockDisponibilidadHorariaRepository } from './MockDisponibilidadHorariaRepository';
import { MockRecordatorioRepository } from './MockRecordatorioRepository';

/**
 * Tipo de entorno de ejecución
 */
export type EnvironmentType = 'development' | 'production';

/**
 * Factoría para crear instancias de repositorios
 */
export class RepositoryFactory {
  private static environment: EnvironmentType = process.env.NODE_ENV === 'production' 
    ? 'production' 
    : 'development';

  /**
   * Configura el entorno para la factoría
   * @param env - Tipo de entorno
   */
  public static setEnvironment(env: EnvironmentType): void {
    this.environment = env;
  }

  /**
   * Obtiene una instancia del repositorio de facturas
   * @returns Una instancia del repositorio de facturas
   */
  public static getInvoiceRepository(): InvoiceRepository {
    if (this.environment === 'production') {
      return new ApiInvoiceRepository();
    } else {
      return new MockInvoiceRepository();
    }
  }

  /**
   * Obtiene una instancia del repositorio de pagos
   * @returns Una instancia del repositorio de pagos
   */
  public static getPaymentRepository(): PaymentRepository {
    if (this.environment === 'production') {
      return new ApiPaymentRepository();
    } else {
      return new MockPaymentRepository();
    }
  }

  /**
   * Obtiene una instancia del repositorio de validación horaria
   * @returns Una instancia del repositorio de validación horaria
   */
  public static getDisponibilidadHorariaRepository(): DisponibilidadHorariaRepository {
    if (this.environment === 'production') {
      return new ApiDisponibilidadHorariaRepository();
    } else {
      return new MockDisponibilidadHorariaRepository();
    }
  }

  /**
   * Obtiene una instancia del repositorio de recordatorios de pago
   * @returns Una instancia del repositorio de recordatorios
   */
  public static getRecordatorioRepository(): RecordatorioRepository {
    if (this.environment === 'production') {
      return new ApiRecordatorioRepository();
    } else {
      return new MockRecordatorioRepository();
    }
  }
} 